module.exports = __webpack_public_path__ + "static/media/icon_tech.b45a6dc2.svg";